import { chaveComConta } from 'dashboard/helper/accountScopedStorage';

// Passagem dos cartões marcados do Kanban para o formulário de campanha.
// Vai por sessionStorage, NUNCA pela URL: uma lista de ids de cartão na barra de
// endereço vaza o tamanho e o conteúdo da seleção em histórico, log de proxy e
// link compartilhado, e estoura o limite de URL numa seleção grande.
// A chave leva o id da conta: ids de cartao sao sequencia por conta, e uma
// passagem aberta numa conta abriria o formulario de campanha da outra com os
// cartoes errados.
export const KANBAN_CAMPAIGN_HANDOFF_KEY = 'siteup:kanban-campaign-audience';

const chave = () => chaveComConta(KANBAN_CAMPAIGN_HANDOFF_KEY);

const storage = () => {
  try {
    return window.sessionStorage;
  } catch (error) {
    return null;
  }
};

export const storeKanbanCampaignAudience = ({
  itemIds = [],
  funnelName = '',
} = {}) => {
  const ids = itemIds.map(Number).filter(Boolean);
  if (!ids.length) return false;
  const store = storage();
  const alvo = chave();
  // Sem conta no contexto nao existe passagem: nao grava.
  if (!store || !alvo) return false;
  try {
    store.setItem(
      alvo,
      JSON.stringify({ itemIds: ids, funnelName, at: Date.now() })
    );
    return true;
  } catch (error) {
    return false;
  }
};

// A leitura NÃO apaga a chave: a tela de Campanhas pode montar duas vezes na
// mesma navegação (alias /v2) e a segunda montagem abriria sem o público. A
// passagem vence sozinha em 2 minutos e é apagada quando a campanha é criada ou
// quando a pessoa limpa os cartões no formulário.
export const KANBAN_CAMPAIGN_HANDOFF_TTL_MS = 120000;

export const clearKanbanCampaignAudience = () => {
  const store = storage();
  const alvo = chave();
  if (!store || !alvo) return;
  try {
    store.removeItem(alvo);
  } catch (error) {
    // nada a limpar
  }
};

export const takeKanbanCampaignAudience = (now = Date.now()) => {
  const store = storage();
  const alvo = chave();
  if (!store || !alvo) return null;
  let raw = null;
  try {
    raw = store.getItem(alvo);
  } catch (error) {
    return null;
  }
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw);
    const itemIds = Array.isArray(parsed?.itemIds)
      ? parsed.itemIds.map(Number).filter(Boolean)
      : [];
    const fresh =
      now - Number(parsed?.at || 0) <= KANBAN_CAMPAIGN_HANDOFF_TTL_MS;
    if (!itemIds.length || !fresh) {
      clearKanbanCampaignAudience();
      return null;
    }
    return { itemIds, funnelName: parsed.funnelName || '' };
  } catch (error) {
    clearKanbanCampaignAudience();
    return null;
  }
};
